module.exports = __webpack_public_path__ + "static/media/question.a40c5591.svg";